import React from 'react';
import TextBlocks from './TextBlocks';
import { useSiteSettings } from './useSiteData';

const AboutUs = () => {
  const { about } = useSiteSettings();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">About Us</h1>
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow">
        <TextBlocks text={about.body} />
      </div>
    </div>
  );
};

export default AboutUs;
